import { animated, useTransition } from 'react-spring';
import { AdminModalBackdropProps } from './admin-modal-backdrop-props';
import { Backdrop } from '../../common';
import React from 'react';

const AnimatedBackdrop = animated(Backdrop);

export const AdminModalBackdrop: React.FunctionComponent<
  AdminModalBackdropProps
> = ({ children, visible, style, ...rest }): React.ReactElement => {
  const backdropTransition = useTransition(visible, null, {
    config: { friction: 26, tension: 100 },
    enter: { opacity: 1 },
    from: { opacity: 0 },
    leave: { opacity: 0 },
  });

  return (
    <React.Fragment>
      {backdropTransition.map(
        ({ item, key, props }) =>
          item && (
            <AnimatedBackdrop
              key={key}
              style={{
                pointerEvents: visible ? 'auto' : 'none',
                ...style,
                ...props,
              }}
              {...rest}
            />
          ),
      )}
    </React.Fragment>
  );
};

AdminModalBackdrop.displayName = 'AdminModalBackdrop';
